import { useQuery } from "@tanstack/react-query";
import { Navigate, useNavigate, useParams } from "react-router-dom";
import { t } from "ttag";

import { ScreenLayout } from "@/app/components/layouts";
import { ROUTES } from "@/app/router";
import {
  useDynamicForm,
  useSubmitMicrodosingCheckInForm,
} from "@/features/forms/hooks";
import { LogoLoader } from "@/shared/components";
import { handleAxiosFieldErrors } from "@/shared/utils";
import { formQueriesStore } from "../api";
import { DynamicForm } from "../components";
import type { Answers } from "../models";

export const MicrodosingCheckInScreen = () => {
  const params = useParams();
  const productId = Number(params.productId);

  const navigate = useNavigate();

  const {
    data: checkInForm,
    isLoading,
    isSuccess,
    isError,
  } = useQuery(formQueriesStore.checkIn(productId));

  const form = useDynamicForm(checkInForm);

  const submitMutation = useSubmitMicrodosingCheckInForm();

  const handleSubmit = (answers: Answers) => {
    if (checkInForm) {
      submitMutation.mutate(
        { productId, formId: checkInForm.formId, answers },
        {
          onSuccess: () => navigate(ROUTES.HOME),
          onError: (err) => handleAxiosFieldErrors(err, form.setError),
        },
      );
    }
  };

  if (isError) {
    return <Navigate to={ROUTES.HOME} />;
  }

  return (
    <ScreenLayout
      hasCardHeader={false}
      title={t`Dietitian form questions`}
      description={t`(*) Mandatory field`}
    >
      {isSuccess && <DynamicForm form={checkInForm} onSubmit={handleSubmit} />}

      <LogoLoader
        show={isLoading || submitMutation.isPending}
        fullscreen={submitMutation.isPending}
      />
    </ScreenLayout>
  );
};
